<!--添加/编辑国家-->
<template>
  <Page class="detailView">
    <div>
      <div class="pageContent-title" v-if="type === 'ADD'">添加国家</div>
      <div class="pageContent-title" v-if="type === 'EDIT'">编辑国家</div>
      <div class="mt-5 detailView-with-actions">
        <a-form class="form" :form="form" :colon="false">
          <a-form-item label="国家名称" required>
            <a-input
              v-decorator="['countryName', { rules: [{ required: true, message: '请输入国家名称' }] }]"
            ></a-input>
          </a-form-item>

          <a-form-item label="是否热门">
            <a-radio-group v-decorator="['hot']">
              <a-radio :value="1">是</a-radio>
              <a-radio :value="0">否</a-radio>
            </a-radio-group>
          </a-form-item>

          <a-form-item label="排序">
            <a-input v-decorator="['sort']" placeholder="数值越大越靠前"></a-input>
          </a-form-item>

          <a-form-item label="国家配图" required>
            <picture-card-upload
              v-decorator="['nationalFlag', { rules: [{ required: true, message: '请上传国家配图' }],initialValue: '', }]"
              :tips="'点击上传国家配图'"
              :itemWidth="200"
              :itemHeight="200"
            />
          </a-form-item>

          <a-form-item label="国家背景图" required>
            <picture-card-upload
              v-decorator="['banner', {
                initialValue: '',
              }]"
              :tips="'点击上传国家背景图'"
              :itemWidth="700"
              :itemHeight="200"
            ></picture-card-upload>
          </a-form-item>
        </a-form>
      </div>
      <div class="detailView-actions">
        <a-button class="app-btn" type="default" @click="back">返回</a-button>
        <a-button class="app-btn" type="primary" @click="doSave">保存</a-button>
      </div>
    </div>
  </Page>
</template>

<script>
import Page from '@/components/Page'
import { toolMixin, queryViewMixin } from '@/utils/mixin'
import PictureCardUpload from '@/components/pictureCardUpload/PictureCardUpload.vue'
export default {
  components: {
    Page,
    PictureCardUpload,
  },
  props: {},
  mixins: [toolMixin, queryViewMixin],
  data() {
    return {
      form: this.$form.createForm(this),
    }
  },
  mounted() {
    console.log('this.$route.query.countryId', this.$route.query.countryId)

    const id = this.$route.query.countryId
    if (id) {
      this.getCountryInfo(id)
    }
  },
  computed: {
    typesMap() {
      return {
        payType: [
          { value: 10, label: '自行支付' },
          { value: 20, label: '平台代付' },
        ],
      }
    },
    type() {
      return this.$route.query.countryId ? 'EDIT' : 'ADD'
    },
    countryId() {
      return this.$route.query.countryId
    },
  },
  methods: {
    back() {
      this.$router.go(-1)
    },
    doSave() {
      console.log(this)
      this.form.validateFields(async (errors, values) => {
        if (!errors) {
          const params = values
          try {
            const countryId = this.$route.query.countryId
            if (countryId) {
              await this.$axios.put('/additional/admin/country/update', {
                countryId: countryId,
                ...params,
              })
              this.$message.success('操作成功')
              this.$router.go(-1)
            } else {
              const res = await this.$axios.post('/additional/admin/country/create', {
                ...params,
              })
              this.$message.success('操作成功')
              this.$router.replace({
                query: {
                  countryId: res.data,
                },
              })
            }
          } catch (e) {
            console.log(e)
          }
        }
      })
    },
    handleOk() {
      this.modal.visible = false
    },
    handleCancel() {
      this.modal.visible = false
    },
    // 查询国家信息
    async getCountryInfo(countryId) {
      this.$axios.get(`/visa/admin/country/${countryId}`).then(res => {
        if (res.success) {
          this.safeSetFieldsValue$t(this.form, res.data)
        }
      })
    },
  },
}
</script>

<style lang="less">
.ant-tag {
  font-size: 16px;
  line-height: 28px;
}
</style>
